import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from '../style/UpgradePrompt.module.css';

const PRODUCT_INFO = {
  chatbot: {
    icon: '🤖',
    title: 'Unlock Chatbot Service',
    description: 'Add AI-powered customer support to your website with our intelligent chatbot.',
    features: [
      'Natural Language Understanding',
      'Custom training for your domain',
      '24/7 automated support',
      'Admin dashboard & analytics'
    ]
  },
  anomaly: {
    icon: '📊',
    title: 'Unlock Anomalieerkennung',
    description: 'Detect patterns and anomalies in your data with advanced AI analytics.',
    features: [
      'Real-time anomaly detection',
      'Smart visualizations',
      'Configurable alerts',
      'ML-powered predictions'
    ]
  }
};

function UpgradePrompt({ product, size = 'normal', showFeatures = false }) {
  const navigate = useNavigate();
  const { plans } = useAuth();
  
  // Don't show if user already has active plan
  if (plans?.[product]?.active) {
    return null;
  }
  
  const productInfo = PRODUCT_INFO[product];
  if (!productInfo) return null;
  
  const cardClass = size === 'small' ? styles.upgradeCardSmall : styles.upgradeCard;
  
  return (
    <div className={cardClass}>
      <div className={styles.upgradeIcon}>{productInfo.icon}</div>
      <div className={styles.upgradeContent}>
        <h3>{productInfo.title}</h3>
        <p>{productInfo.description}</p>
        {showFeatures && (
          <ul className={styles.featuresList}>
            {productInfo.features.map((feature, index) => (
              <li key={index}>✓ {feature}</li>
            ))}
          </ul>
        )}
        <button 
          className={styles.upgradeButton}
          onClick={() => navigate(`/price?need=${product}`)}
        >
          Start Free Trial →
        </button>
      </div>
    </div>
  );
}

export default UpgradePrompt;
